import type { SemanticColor } from '@atlaskit/lozenge/types';

import { SPF_ASK_STATUS_CONFIG } from './spf-ask-status-config';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { SPF_ASK_STATUS_CONFIG } from './spf-ask-status-config';

export const getAskStatusAppearance = (status?: string): SemanticColor => {
	return SPF_ASK_STATUS_CONFIG[status ?? '']?.appearance ?? 'neutral';
};

export const formatSpfAskStatus = (status?: string): string | undefined => {
	return status ? SPF_ASK_STATUS_CONFIG[status]?.display : undefined;
};
